import React, { useState } from 'react';

const EditableUnitChip = ({ label, editable, validate, onSubmitted, onRemove }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(label);
  const [error, setError] = useState(null);

  const startEdit = () => {
    if (!editable) return;
    setValue(label);
    setError(null);
    setEditing(true);
  };

  const commit = () => {
    const trimmed = value.trim();
    const validationError = validate?.(trimmed);
    if (validationError) {
      setError(validationError);
      return;
    }
    setEditing(false);
    setError(null);
    onSubmitted?.(trimmed);
  };

  const cancel = () => {
    setValue(label);
    setError(null);
    setEditing(false);
  };

  if (editing) {
    return (
      <span className="community-unit-chip community-unit-chip-editing">
        <input
          type="text"
          value={value}
          autoFocus
          onChange={e => {
            setValue(e.target.value);
            if (error) setError(null);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') commit();
            if (e.key === 'Escape') cancel();
          }}
          onBlur={commit}
        />
        {error && <span className="community-unit-chip-error">{error}</span>}
      </span>
    );
  }

  if (onRemove) {
    return (
      <span className="community-unit-chip-pill">
        <button
          type="button"
          className={`community-unit-chip-label ${editable ? 'editable' : ''}`}
          onClick={startEdit}
          disabled={!editable}
        >
          {label}
        </button>
        <button
          type="button"
          className="community-unit-chip-remove"
          aria-label={`Remove ${label}`}
          onClick={e => {
            e.stopPropagation();
            onRemove();
          }}
        >
          ×
        </button>
      </span>
    );
  }

  return (
    <button
      type="button"
      className={`community-unit-chip ${editable ? 'editable' : ''}`}
      onClick={startEdit}
      disabled={!editable}
    >
      {label}
    </button>
  );
};

export default EditableUnitChip;
